/** The palette's catalog query, which lists widgets among the tools. */
// eslint-disable-next-line i18next/no-literal-string -- cache key segments, not user-facing
export const CANVAS_TOOLS_KEY = ['agentic-ui', 'catalog', 'tools'];
